var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImprovesMinutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 65,
    width: 70.8,
    x: 14.6,
    y: -82.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,53.7c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1S16,53.7,12,53.7z M12,42 c-2.5,0-4.6,2-4.6,4.6s2,4.6,4.6,4.6s4.6-2,4.6-4.6S14.5,42,12,42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,68.5H0.6v-6.1C0.6,56.1,5.7,51,12,51s11.4,5.1,11.4,11.4V68.5z M3.2,65.9h17.7v-3.6 c0-4.9-4-8.8-8.8-8.8s-8.8,4-8.8,8.8V65.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,53.7c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1S63.9,53.7,60,53.7z M60,42 c-2.5,0-4.6,2-4.6,4.6s2,4.6,4.6,4.6s4.6-2,4.6-4.6S62.5,42,60,42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,68.5H48.6v-6.1C48.6,56.1,53.7,51,60,51s11.4,5.1,11.4,11.4V68.5z M51.2,65.9h17.7v-3.6 c0-4.9-4-8.8-8.8-8.8s-8.8,4-8.8,8.8V65.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5,50.8c-0.5,0-1.1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-2l8.7-4.7v-7.7c0-0.8,0.7-1.5,1.5-1.5 s1.5,0.7,1.5,1.5v9.5l-10.3,5.5C27,50.8,26.7,50.8,26.5,50.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.5,50.8c-0.2,0-0.5-0.1-0.7-0.2l-10.3-5.5v-9.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v7.7l8.7,4.7 c0.7,0.4,1,1.3,0.6,2C46.6,50.5,46.1,50.8,45.5,50.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,32.2c-7.9,0-14.4-6.5-14.4-14.4S28.6,3.5,36.5,3.5c7.9,0,14.4,6.5,14.4,14.4S44.5,32.2,36.5,32.2z  M36.5,6.5c-6.3,0-11.4,5.1-11.4,11.4s5.1,11.4,11.4,11.4s11.4-5.1,11.4-11.4S42.8,6.5,36.5,6.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,23.4l-0.7-0.6c-3.9-3.5-4.2-3.9-4.2-4.1c-0.2-0.5,0-1.1,0.4-1.3c0.5-0.2,1-0.1,1.3,0.4 c0.3,0.3,1.7,1.7,3.1,2.9l7.4-7.4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L35,23.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovesMinutes);
export default __webpack_public_path__ + "static/media/improves-minutes.dd2b19386392d12e602ff97a04cb8e0e.svg";
export { ForwardRef as ReactComponent };